import { rem } from 'polished';
import styled from 'styled-components';

import { Checkbox as BokehCheckbox, Text } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';
import { Checkbox } from '@vimeo/iris/components';
import { Paragraph } from '@vimeo/iris/typography';

import { HR } from './emailForms/Shared';

const CheckboxContainer = styled.div`
  margin-top: ${rem(8)};
`;

const FormSection = styled.section`
  margin-top: ${rem(10)};
  display: flex;
  flex-direction: column;
`;

interface Props {
  hideHorizontalRule?: boolean;
  marketingOptIn: boolean;
  marketingOptInHandler: VoidFunction;
  isSimplifiedSite?: boolean;
  isFullScreen?: boolean;
}

const RenderMarketingCheckBox = ({
  hideHorizontalRule,
  marketingOptIn,
  marketingOptInHandler,
  isSimplifiedSite,
  isFullScreen = false,
}: Props) => {
  return (
    <FormSection>
      {isFullScreen ? (
        <BokehCheckbox
          size="md"
          isChecked={marketingOptIn}
          onChange={marketingOptInHandler}
          id="marketing_opt_in"
        >
          <Text variant="body-sm" color="text-secondary">
            {isSimplifiedSite
              ? translate(
                  'I agree to receive newsletters, product updates, and exclusive offers from VideoJi.',
                )
              : translate('I agree to receive newsletters, updates, and offers')}
          </Text>
        </BokehCheckbox>
      ) : (
        <CheckboxContainer className="marketing-opt-in-checkbox">
          <Checkbox
            checked={marketingOptIn}
            onChange={marketingOptInHandler}
            id="marketing_opt_in"
            label={
              <Paragraph size="3">
                {isSimplifiedSite
                  ? translate(
                      'I agree to receive newsletters, product updates, and exclusive offers from VideoJi.',
                    )
                  : translate(
                      'I agree to receive newsletters, product updates, and exclusive offers from Vimeo.',
                    )}
              </Paragraph>
            }
          />
        </CheckboxContainer>
      )}
      {!hideHorizontalRule && <HR />}
    </FormSection>
  );
};

export default RenderMarketingCheckBox;
